<script>
import appConfig from '@src/app.config'

export default {
  computed: {
    version() {
      const versionMap = {
        'dingsomething.daydream-lab.com': '',
        'demo.dingsomething.com': '',
        'dingsomething.com': '',
      };

      return versionMap[location.hostname] || ''
    },
  },
  render() {
    return (
      <footer class={(this.$route.name === 'booking-product' || this.$route.name === 'booking-prepaid-item') ? 'footer has-next-step-section' : 'footer'}>
        <div class="content has-text-centered">
          <p>
            Powered by
            <a href="/" target="_blank" class={this.$style.link}>
              {appConfig.title}
            </a>
          </p>
          <p>v2.0.4{this.version}</p>
        </div>
      </footer>
    )
  },
}
</script>
<style lang="scss" module>
.link {
  margin-left: 5px;
}
</style>

